import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-zone-guide-intro': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20warm%20neutral%20tones%2C%20soft%20geometric%20shapes%2C%20clean%20editorial%20design%20background%2C%20subtle%20texture%2C%20modern%20aesthetic%20with%20gentle%20gradients%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%201&width=800&height=480&seq=article-zone-guide-intro&orientation=landscape',
  'article-zone1-tips': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20soft%20cream%20and%20beige%20tones%2C%20clean%20geometric%20patterns%2C%20editorial%20design%20background%2C%20gentle%20texture%2C%20modern%20aesthetic%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%202&width=800&height=480&seq=article-zone1-tips&orientation=landscape',
  'article-zone2-advanced': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20warm%20terracotta%20tones%2C%20soft%20geometric%20layers%2C%20clean%20editorial%20design%20background%2C%20modern%20aesthetic%20with%20subtle%20gradients%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%203&width=800&height=480&seq=article-zone2-advanced&orientation=landscape',
  'article-zone2-case': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20warm%20sand%20tones%2C%20soft%20geometric%20shapes%2C%20clean%20editorial%20design%2C%20modern%20aesthetic%20with%20gentle%20textures%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%204&width=800&height=480&seq=article-zone2-case&orientation=landscape',
  'article-zone3-insight': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20deep%20warm%20burgundy%20tones%2C%20soft%20geometric%20layers%2C%20editorial%20design%20background%2C%20modern%20aesthetic%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%205&width=800&height=480&seq=article-zone3-insight&orientation=landscape',
  'article-zone3-review': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20warm%20ochre%20tones%2C%20soft%20geometric%20patterns%2C%20clean%20editorial%20design%2C%20modern%20aesthetic%20with%20subtle%20textures%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%206&width=800&height=480&seq=article-zone3-review&orientation=landscape',
  'article-comparison': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20warm%20neutral%20tones%2C%20soft%20geometric%20shapes%20overlapping%2C%20clean%20editorial%20design%20background%2C%20modern%20aesthetic%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%207&width=800&height=480&seq=article-comparison&orientation=landscape',
  'article-standard': 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20warm%20beige%20tones%2C%20soft%20geometric%20layers%2C%20clean%20editorial%20design%2C%20modern%20aesthetic%20with%20gentle%20gradients%2C%20high%20quality%20abstract%20wallpaper%20for%20article%20header%208&width=800&height=480&seq=article-standard&orientation=landscape',
};

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  const getCategoryColor = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    if (!cat) return 'bg-secondary-100 text-secondary-700';
    const map: Record<string, string> = {
      accent: 'bg-accent-100 text-accent-700',
      primary: 'bg-primary-100 text-primary-700',
      secondary: 'bg-secondary-100 text-secondary-700',
    };
    return map[cat.color] || 'bg-secondary-100 text-secondary-700';
  };

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-14 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              最新文章
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              精选内容推荐
            </h2>
          </div>
          <Link
            to="/category/zone-1"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || articleImages['article-zone-guide-intro']}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getCategoryColor(article.category)}`}>
                    {getCategoryName(article.category)}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}